import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppFab from "@/components/WhatsAppFab";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import SiteInspection from "@/pages/SiteInspection";
import BoqBillReview from "@/pages/BoqBillReview";
import ConstructionRenovation from "@/pages/ConstructionRenovation";
import MaintenanceConsultancy from "@/pages/MaintenanceConsultancy";
import LandscapingConsultancy from "@/pages/LandscapingConsultancy";
import HowItWorks from "@/pages/HowItWorks";
import WhoWeHelp from "@/pages/WhoWeHelp";
import Contact from "@/pages/Contact";
import Faq from "@/pages/Faq";
import Admin from "@/pages/Admin";

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
}

function Layout() {
    const { pathname } = useLocation();
    const isAdmin = pathname.startsWith("/admin");

    useEffect(() => {
        const lenis = new Lenis({ duration: 1.05, smoothWheel: true });
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
        };
    }, []);

    return (
        <div className="min-h-screen">
            {!isAdmin && <Header />}
            <main>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/services" element={<Services />} />
                    <Route path="/site-inspection" element={<SiteInspection />} />
                    <Route path="/boq-bill-review" element={<BoqBillReview />} />
                    <Route path="/construction-renovation-consultancy" element={<ConstructionRenovation />} />
                    <Route path="/maintenance-consultancy" element={<MaintenanceConsultancy />} />
                    <Route path="/landscaping-consultancy" element={<LandscapingConsultancy />} />
                    <Route path="/how-it-works" element={<HowItWorks />} />
                    <Route path="/who-we-help" element={<WhoWeHelp />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/faq" element={<Faq />} />
                    <Route path="/admin" element={<Admin />} />
                    <Route path="*" element={<Home />} />
                </Routes>
            </main>
            {!isAdmin && <Footer />}
            {!isAdmin && <WhatsAppFab />}
            <Toaster position="top-center" richColors />
        </div>
    );
}

function App() {
    return (
        <BrowserRouter>
            <ScrollToTop />
            <Layout />
        </BrowserRouter>
    );
}

export default App;
